export default {
    zh: {
        title: 'FPA-LTO',
        serialNo:'FPA批次号',
        detail :'FPA-LTO > 详情',
        PriceValidDateCheck1:' 没有维护Price Valid Date',
        PriceValidDateCheck2:' : Price Valid Date开始时间不能晚于结束时间',

    },
    en: {
        title: 'FPA-LTO',
        serialNo:'Serial No',
        detail :'FPA-LTO > View',
        PriceValidDateCheck1:' have not maintained price valid date',
        PriceValidDateCheck2:' : price valid to date is earlier than price valid from date',
    }
}